/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Prefecture
 */
export interface Prefecture {
    /**
     * 
     * @type {string}
     * @memberof Prefecture
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Prefecture
     */
    name: string;
}

/**
 * Check if a given object implements the Prefecture interface.
 */
export function instanceOfPrefecture(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function PrefectureFromJSON(json: any): Prefecture {
    return PrefectureFromJSONTyped(json, false);
}

export function PrefectureFromJSONTyped(json: any, ignoreDiscriminator: boolean): Prefecture {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function PrefectureToJSON(value?: Prefecture | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

